import React from "react";
import Banner from "../components/ContactUs/Banner";
import HelpText from "../components/ContactUs/HelpText";
import FAQs from "../components/FAQs";

const FAQsContainer = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5rem",
      }}
    >
      <Banner
        header="Frequently Asked Questions"
        text="We are a dependable marketplace for refurbished mobilephones, laptops, and other tech gadgets."
      />
      <HelpText
        header="Hey!"
        text="We know you need help. Please find the FAQs that we already answered."
      />
      <FAQs />
    </div>
  );
};

export default FAQsContainer;
